import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Folder, FolderUID} from "./types/folder";
import {File, FileUID} from "./types/file";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FileManagerService {
  constructor(private http: HttpClient) {
  }

  public listFolders(): Observable<Folder[]> {
    return this.http.get<Folder[]>(`${environment.api.url}/ui/v1/folders`)
  }

  public createFolder(name: string, order: number): Observable<Folder> {
    return this.http.post<Folder>(`${environment.api.url}/ui/v1/folder`, {
      name: name,
      sortOrder: order,
    })
  }

  public renameFolder(id: string, name: string): Observable<Folder> {
    return this.http.put<Folder>(`${environment.api.url}/ui/v1/folder/${id}`, {
      name: name
    })
  }

  public deleteFolder(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.api.url}/ui/v1/folder/${id}`)
  }

  public updateFolders(folders: Folder[]) {
    return this.http.put<Folder[]>(`${environment.api.url}/ui/v1/folders`, {
      folders: folders
    })
  }

  public getFiles(id: string): Observable<File[]> {
    return this.http.get<File[]>(`${environment.api.url}/ui/v1/folder/${id}/files`)
  }

  public getFile(id: FileUID): Observable<File> {
    return this.http.get<File>(`${environment.api.url}/ui/v1/file/${id}`)
  }

  public deleteFile(id: FileUID): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.api.url}/ui/v1/file/${id}`)
  }

  public moveFile(file: FileUID, folder: FolderUID): Observable<File> {
    return this.http.put<File>(`${environment.api.url}/ui/v1/move-file`, {
      fileId: file,
      folderId: folder,
    })
  }

  public saveFile(id: FileUID, label: string): Observable<File> {
    return this.http.put<File>(`${environment.api.url}/ui/v1/file/${id}`, {
      label: label
    })
  }

  public saveFileLabels(id: FileUID, labels: Record<string, string | null>): Observable<File> {
    return this.http.put<File>(`${environment.api.url}/ui/v1/file/${id}`, {
      labels: labels
    })
  }
}
